import { Component, input, InputSignal } from '@angular/core';

// Animated "Action Tracker + AI" illustration (`assets/images/action-tracker-ai.svg`). The animation lives inside the
// SVG and stops on its own when the user prefers reduced motion. Sized by its host: give the element a width.
@Component({
  selector: 'app-ai-illustration',
  standalone: true,
  styleUrl: './ai-illustration.component.scss',
  templateUrl: './ai-illustration.component.html',
})
export class AiIllustrationComponent {
  /** Text alternative; leave empty when the illustration is decorative (surrounding text says the same). */
  public readonly alt: InputSignal<string> = input<string>('');
}
